import React, { useEffect, useState } from 'react'
import { useJobsStore } from '../../Store/useJobsStore'

export const useJobsList = () => {
    const filteredAndSearchedJobs = useJobsStore((state) => state.filteredAndSearchedJobs)
    const currentSearchTerm = useJobsStore((state) => state.currentSearchTerm)
    const activeFilterTagUids = useJobsStore((state) => state.activeFilterTagUids)
    const resetFilterState = useJobsStore((state) => state.resetFilterState)

    const [jobs, setJobs] = useState(null)
    const [jobsNumber, setJobsNumber] = useState(15)
    const [allShown, setAllShown] = useState(false)

    useEffect(() => {
        resetFilterState()
    }, [])

    useEffect(() => {
        const newJobs = filteredAndSearchedJobs()
        if (newJobs.length <= 15) {
            setJobsNumber(newJobs.length)
            setAllShown(true)
        } else {
            setJobsNumber(15)
            setAllShown(false)
        }
        setJobs(newJobs)
    }, [currentSearchTerm, activeFilterTagUids])

    const increaseJobsNumber = () => {
        const newNumber = jobsNumber + 15
        if (newNumber <= jobs.length) {
            setJobsNumber(newNumber)
            setAllShown(false)
        } else {
            setJobsNumber(jobs.length)
            setAllShown(true)
        }
    }

    return { jobsNumber, increaseJobsNumber, jobs, allShown }
}
